import {useEffect, useState} from "react";
import AccountService from "../services/account.service";

const useUsers = ({organizationId, justUser = false}) => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const loadUsers = async () => {
        if (!organizationId) return;
        setLoading(true);
        const data = await AccountService.getpartnerinfo(organizationId, justUser);
        setUsers(data.data.users);
        setLoading(false);
    };

    useEffect(() => {
        loadUsers();
    }, [organizationId, justUser]);

    return {users, loading, reload: loadUsers};
}

export default useUsers;